export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";

export const FETCH_ALL_BRANCH = "FETCH_ALL_BRANCH";
export const FETCH_ALL_BRANCH_SUCCESS = "FETCH_ALL_BRANCH_SUCCESS";
export const FETCH_ALL_BRANCH_FAILED = "FETCH_ALL_BRANCH_FAILED";

export const FETCH_COUNTRY = "FETCH_COUNTRY";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILED = "FETCH_COUNTRY_FAILED";

export const FETCH_STATE = "FETCH_STATE";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";

export const FETCH_CITY = "FETCH_CITY";
export const FETCH_CITY_SUCCESS = "FETCH_CITY_SUCCESS";
export const FETCH_CITY_FAILED = "FETCH_CITY_FAILED";

export const UPDATE_BRANCH = "UPDATE_BRANCH";
export const UPDATE_BRANCH_SUCCESS = "UPDATE_BRANCH_SUCCESS";
export const UPDATE_BRANCH_FAILED = "UPDATE_BRANCH_FAILED";

export const FETCH_SINGLE_BRANCH = "FETCH_SINGLE_BRANCH";
export const FETCH_SINGLE_BRANCH_SUCCESS = "FETCH_SINGLE_BRANCH_SUCCESS";
export const FETCH_SINGLE_BRANCH_FAILED = "FETCH_SINGLE_BRANCH_FAILED";

export const FETCH_BRANCH_USER = "FETCH_BRANCH_USER";
export const FETCH_BRANCH_USER_SUCCESS = "FETCH_BRANCH_USER_SUCCESS";
export const FETCH_BRANCH_USER_FAILED = "FETCH_BRANCH_USER_FAILED";

export const FETCH_COUNTRY_BRANCH = "FETCH_COUNTRY_BRANCH";
export const FETCH_COUNTRY_BRANCH_SUCCESS = "FETCH_COUNTRY_BRANCH_SUCCESS";
export const FETCH_COUNTRY_BRANCH_FAILED = "FETCH_COUNTRY_BRANCH_FAILED";

export const FETCH_STATE_BRANCH = "FETCH_STATE_BRANCH";
export const FETCH_STATE_BRANCHSUCCESS = "FETCH_STATE_BRANCHSUCCESS";
export const FETCH_STATE_BRANCHFAILED = "FETCH_STATE_BRANCHFAILED";

export const FETCH_CITY_BRANCH = "FETCH_CITY_BRANCH";
export const FETCH_CITY_BRANCHSUCCESS = "FETCH_CITY_BRANCHSUCCESS";
export const FETCH_CITY_BRANCHFAILED = "FETCH_CITY_BRANCHFAILED";

export const DELETE_BRANCH = "DELETE_BRANCH";
export const DELETE_BRANCH_SUCCESS = "DELETE_BRANCH_SUCCESS";
export const DELETE_BRANCH_FAILED = "DELETE_BRANCH_FAILED";

export const CREATE_TESTIMONIAL = "CREATE_TESTIMONIAL";
export const CREATE_TESTIMONIAL_SUCCESS = "CREATE_TESTIMONIAL_SUCCESS";
export const CREATE_TESTIMONIAL_FAILED = "CREATE_TESTIMONIAL_FAILED";

export const FETCH_APPLIED_BRANCH = "FETCH_APPLIED_BRANCH";
export const FETCH_APPLIED_BRANCH_SUCCESS = "FETCH_APPLIED_BRANCH_SUCCESS";
export const FETCH_APPLIED_BRANCH_FAILED = "FETCH_APPLIED_BRANCH_FAILED";

export const CREATE_APPLIED_BRANCH = "CREATE_APPLIED_BRANCH";
export const CREATE_APPLIED_BRANCH_SUCCESS = "CREATE_APPLIED_BRANCH_SUCCESS";
export const CREATE_APPLIED_BRANCH_FAILED = "CREATE_APPLIED_BRANCH_FAILED";

export const UPDATE_APPLIED_BRANCH = "UPDATE_APPLIED_BRANCH";
export const UPDATE_APPLIED_BRANCH_SUCCESS = "UPDATE_APPLIED_BRANCH_SUCCESS";
export const UPDATE_APPLIED_BRANCH_FAILED = "UPDATE_APPLIED_BRANCH_FAILED";

export const CHANGE_MODERATION_STATUS = "CHANGE_MODERATION_STATUS";
export const CHANGE_MODERATION_STATUS_SUCCESS =
  "CHANGE_MODERATION_STATUS_SUCCESS";
export const CHANGE_MODERATION_STATUS_FAILED =
  "CHANGE_MODERATION_STATUS_FAILED";

export const FETCH_DEALER_PROFILE = "FETCH_DEALER_PROFILE";
export const FETCH_DEALER_PROFILE_SUCCESS = "FETCH_DEALER_PROFILE_SUCCESS";
export const FETCH_DEALER_PROFILE_FAILED = "FETCH_DEALER_PROFILE_FAILED";

export const SET_UPDATE_BUTTON_CLICK_PLACE = "SET_UPDATE_BUTTON_CLICK_PLACE";
